document.addEventListener("DOMContentLoaded", function() {
    var variantDetailsDiv = document.querySelector('.variants-details');
    if (variantDetailsDiv) {
       var variantListItems = variantDetailsDiv.querySelectorAll('li'); 
    
    
      var variantsDictionary = {};
  
      variantListItems.forEach(function(item) {
        var text = item.textContent.trim();
        var [variantName, variantId] = text.split(' : ');
        variantsDictionary[variantName] = variantId;
      });
  
      console.log(variantsDictionary);
  
      function updateDisplayBasedOnSelection(value) {
          var selectedClass = variantsDictionary[value];
          if (selectedClass) {
              var selectedElement = document.querySelector(`.${selectedClass}`);
              if (selectedElement) {
                  selectedElement.style.display = 'block';
              }
          }
      }
  
      var selectElement = document.querySelector('.select__select');
      var timeoutId;
  
      selectElement.addEventListener('change', function(event) {
          var selectedValue = event.target.value;
          clearTimeout(timeoutId); 
          timeoutId = setTimeout(function() {
              updateDisplayBasedOnSelection(selectedValue);
          }, 500); 
      });
  
      updateDisplayBasedOnSelection(selectElement.value);
    }
});

